module.exports = __webpack_public_path__ + "static/media/consultant.faefc0cd.svg";